import { Collapse, List, Stack } from '@cmg/design-system';
import React, { useCallback, useEffect, useState } from 'react';

import { useOfferingSidePanelRouteMatch } from '../../../../hooks/useOfferingSidePanelMatch';
import { NavItemGroup } from '../../../../hooks/useSidePanelSellSideNavItems';
import { SideNavbarItem } from './SideNavbarItem';

type SideNavbarSubNavigationItemProps = Readonly<{
  navItemGroup: NavItemGroup;
}>;

export function SideNavbarSubNavigationItem({ navItemGroup }: SideNavbarSubNavigationItemProps) {
  const expandSubNavigation = useOfferingSidePanelRouteMatch(navItemGroup.routePath);
  const [subNavigationOpen, setSubNavigationOpen] = useState(expandSubNavigation);

  useEffect(() => {
    if (expandSubNavigation) {
      setSubNavigationOpen(true);
    }
  }, [expandSubNavigation]);

  const onSubNavigationClick = useCallback(() => {
    setSubNavigationOpen(!subNavigationOpen);
  }, [subNavigationOpen]);

  return (
    <Stack>
      <SideNavbarItem
        key={navItemGroup.id}
        icon={navItemGroup.icon}
        expanded={subNavigationOpen}
        onClick={onSubNavigationClick}
        href={navItemGroup.href}
      >
        {navItemGroup.label}
      </SideNavbarItem>
      <Collapse in={subNavigationOpen} timeout="auto" unmountOnExit>
        <List component="div" role="menubar">
          {navItemGroup.items.map(subItem => (
            <SideNavbarItem
              key={subItem.id}
              icon={subItem.icon}
              href={subItem.href}
              selected={subItem.selected}
            >
              {subItem.label}
            </SideNavbarItem>
          ))}
        </List>
      </Collapse>
    </Stack>
  );
}
